import { z } from 'zod';
import { trimStringToNull } from '~/util';
import { baseUserSchema } from '../types/users';

export const clanFormSchema = z.object({
    global_name: z
        .string()
        .min(1, 'The clan name must be at least 1 character.')
        .max(100, 'The clan name must be at most 100 characters.')
        .transform(trimStringToNull),
    description: z
        .string()
        .max(300, 'The clan description must be at most 300 characters.')
        .nullable()
        .transform(trimStringToNull),
    tag: z
        .string()
        .min(1, 'The clan tag must be at least 1 character.')
        .max(5, 'The clan tag must be at most 5 characters.')
        .transform(trimStringToNull),
});

export type clanFormInput = z.input<typeof clanFormSchema>;
export type clanFormOutput = z.output<typeof clanFormSchema>;

export const clanMemberFormSchema = z.object({
    role: z.enum(['0', '1', '2']).transform((val) => Number(val)),
});

export type clanMemberFormInput = z.input<typeof clanMemberFormSchema>;
export type clanMemberFormOutput = z.output<typeof clanMemberFormSchema>;

export const addClanMemberFormSchema = z.object({
    member: baseUserSchema.nullable(),
});

export type addClanMemberFormInput = z.input<typeof addClanMemberFormSchema>;
export type addClanMemberFormOutput = z.output<typeof addClanMemberFormSchema>;
